export const breakpoints = {
  sm: "564px",
  lg: "1100px",
};

export default { breakpoints };
